import Menu from '@/global/components/Menu'
import { Button } from '@/global/components/ui/button'
import { EllipsisVerticalIcon } from 'lucide-react'

export function renderActions(actions: React.ReactNode) {
    if (!actions) return null
    if (Array.isArray(actions) && !actions.length) return null
    return (
        <Menu.Root arrow>
            <Menu.Trigger>
                <Button
                    type="button"
                    variant="ghost"
                    size="icon"
                    className="size-10 rounded-full"
                >
                    <EllipsisVerticalIcon />
                </Button>
            </Menu.Trigger>
            <Menu.List>{actions}</Menu.List>
        </Menu.Root>
    )
}
